
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getVendorProfile,getCustomerByPhone, updateVendorProfile,vendorDashboardDetails,createVendorFundAccount,validateVendorBankAccount} from '../thunkMidddleware/usersMiddleware';
import BaseApiState, { createBaseAPi } from "@/api/BaseApiState"

interface AddressDetails {
  address: string;
  locality: string;
  city: string;
  state: string;
  pincode: string;
  googleLocationUrl?: string;
}

interface BankDetails {
  bankName: string;
  accountHolderName: string;
  accountNumber: string;
  ifsc: string;
  upiId: string;
  isVerified: boolean;
  verificationMessage: string;
  verificationStatus: string;
  createdAt?: string;
  updatedAt?: string;
}
interface BasicDetails {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  profileVerified: boolean;
}

interface ProfileState {
  addressDetails: AddressDetails;
  bankDetails: BankDetails;
  isAddressCompleted: boolean;
  isBankDetailsCompleted: boolean;
  isBankVerified: boolean;

  loading: boolean;
  error: string | null;
  vendorProfile: createBaseAPi;
  basicDetails: BasicDetails,
  isBasicDetailsCompleted: boolean,
  updateVendorProfile: createBaseAPi,
  vendorDashboardDetailsResponse:createBaseAPi,
  createVendorFundAccountResponse:createBaseAPi,
  validateVendorBankAccountResponse:createBaseAPi,
  getCustomerByPhoneResponse:createBaseAPi,
}

const initialState: ProfileState = {
  getCustomerByPhoneResponse:BaseApiState,
  createVendorFundAccountResponse:BaseApiState,
  validateVendorBankAccountResponse:BaseApiState,
  basicDetails: {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    profileVerified: false,
  },
  addressDetails: {
    address: '',
    locality: '',
    city: '',
    state: '',
    pincode: '',
    googleLocationUrl: '',

  },
  bankDetails: {
    bankName: '',
    accountHolderName: '',
    accountNumber: '',
    ifsc: '',
    upiId: '',
    isVerified: false,
    verificationMessage: '',
    verificationStatus: '',
    createdAt: '',
    updatedAt: '',
  },
  isAddressCompleted: false,
  isBankDetailsCompleted: false,
  isBankVerified:false,
  loading: false,
  error: null,
  vendorProfile: BaseApiState,
  updateVendorProfile: BaseApiState,

  isBasicDetailsCompleted: false,
  vendorDashboardDetailsResponse:BaseApiState

};

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    updateBasicDetails: (state, action: PayloadAction<Partial<BasicDetails>>) => {
      state.basicDetails = { ...state.basicDetails, ...action.payload };
    },
    updateAddressDetails: (state, action: PayloadAction<Partial<AddressDetails>>) => {
      state.addressDetails = { ...state.addressDetails, ...action.payload };
    },
    updateBankDetails: (state, action: PayloadAction<Partial<BankDetails>>) => {
      state.bankDetails = { ...state.bankDetails, ...action.payload };
    },
    setAddressCompleted: (state, action: PayloadAction<boolean>) => {
      state.isAddressCompleted = action.payload;
    },
    setBankDetailsCompleted: (state, action: PayloadAction<boolean>) => {
      state.isBankDetailsCompleted = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setBasicDetailsCompleted: (state, action: PayloadAction<boolean>) => {
      state.isBasicDetailsCompleted = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getVendorProfile.pending, (state) => {
        state.vendorProfile.isLoading = true;
        state.vendorProfile.error = null;
        state.vendorProfile.success = false
      })
      .addCase(getVendorProfile.fulfilled, (state, action) => {
        let { payload, message } = action.payload
        state.vendorProfile.isLoading = false;
        state.vendorProfile.payload = payload;
        state.addressDetails = payload?.address;
        state.bankDetails = payload?.bankDetails;
        state.isAddressCompleted = payload?.isAddressCompleted;
        // state.isBankDetailsCompleted = payload?.isBankDetailsCompleted && payload?.bankDetails?.isVerified;
        state.isBankDetailsCompleted = payload?.isBankDetailsCompleted 

        state.isBankVerified = payload?.bankDetails?.isVerified;
        state.isBasicDetailsCompleted = !!(payload?.email && payload?.firstName && payload?.phone)
        let basicDetailsOfVendor={
          email: payload?.email,
          firstName: payload?.firstName || '',
          lastName: payload?.lastName || '',
          phone: payload?.phone || '',
          profileVerified: payload?.vendorProfileCompleted
        }
        state.basicDetails = basicDetailsOfVendor

        sessionStorage.setItem("profile",JSON.stringify(basicDetailsOfVendor))

        state.vendorProfile.success = true;
        state.vendorProfile.message = message || payload?.message || '';


      })
      .addCase(getVendorProfile.rejected, (state, action) => {
        state.vendorProfile.isLoading = false;
        // state.error = action?.error as string;
        state.vendorProfile.success = false

      });

    // --------------------------------------------------------------------------------

    builder
      .addCase(updateVendorProfile.pending, (state) => {
        state.updateVendorProfile.isLoading = true;
        state.updateVendorProfile.error = null;
        state.updateVendorProfile.success = false
      })
      .addCase(updateVendorProfile.fulfilled, (state, action) => {
        let { payload, message } = action.payload
        state.updateVendorProfile.isLoading = false;
        state.updateVendorProfile.payload = payload;
        state.vendorProfile.payload = payload
        state.addressDetails = payload?.address;
        state.bankDetails = payload?.bankDetails;
        state.isAddressCompleted = payload?.isAddressCompleted;
        state.isBankDetailsCompleted = payload?.isBankDetailsCompleted;
        state.basicDetails = {
          email: payload?.email,
          firstName: payload?.firstName || '',
          lastName: payload?.lastName || '',
          phone: payload?.phone || '',
          profileVerified: payload?.vendorProfileCompleted

        }
        state.updateVendorProfile.success = true;
        state.updateVendorProfile.message = message || payload?.message || '';


      })
      .addCase(updateVendorProfile.rejected, (state, action) => {
        state.updateVendorProfile.isLoading = false;
        // state.error = action?.error as string;
        state.updateVendorProfile.success = false
      });


          // --------------------------------------------------------------------------------
    // --------------------------------------------------------------------------------

    builder
      .addCase(createVendorFundAccount.pending, (state) => {
        state.updateVendorProfile.isLoading = true;
        state.updateVendorProfile.error = null;
        state.updateVendorProfile.success = false

        state.createVendorFundAccountResponse.isLoading =  true
        state.createVendorFundAccountResponse.error =  null
        state.createVendorFundAccountResponse.success = false


      })
      .addCase(createVendorFundAccount.fulfilled, (state, action) => {
        let { payload, message } = action.payload
        state.createVendorFundAccountResponse.isLoading = false;
        state.createVendorFundAccountResponse.payload =  payload
        state.createVendorFundAccountResponse.success = true
        state.createVendorFundAccountResponse.message = message || ''

        state.updateVendorProfile.isLoading = false;
        state.updateVendorProfile.payload = payload;
        state.vendorProfile.payload = payload
        state.addressDetails = payload?.address;
        state.bankDetails = payload?.bankDetails;
        state.isAddressCompleted = payload?.isAddressCompleted;
        state.isBankDetailsCompleted = payload?.isBankDetailsCompleted;
        state.basicDetails = {
          email: payload?.email,
          firstName: payload?.firstName || '',
          lastName: payload?.lastName || '',
          phone: payload?.phone || '',
          profileVerified: payload?.vendorProfileCompleted

        }
        state.updateVendorProfile.success = true;
        state.updateVendorProfile.message = message || payload?.message || '';


      })
      .addCase(createVendorFundAccount.rejected, (state, action) => {
        state.updateVendorProfile.isLoading = false;
        // state.error = action?.error as string;
        state.updateVendorProfile.success = false


        state.createVendorFundAccountResponse.isLoading =  false
        state.createVendorFundAccountResponse.error =   action?.error ||action?.payload || "Something went wrong"
        state.createVendorFundAccountResponse.success = false  
      });


         // --------------------------------------------------------------------------------

    builder
    .addCase(validateVendorBankAccount.pending, (state) => {
      state.updateVendorProfile.isLoading = true;
      state.updateVendorProfile.error = null;
      state.updateVendorProfile.success = false

      state.validateVendorBankAccountResponse.isLoading =  true
      state.validateVendorBankAccountResponse.error =  null
      state.validateVendorBankAccountResponse.success = false


    })
    .addCase(validateVendorBankAccount.fulfilled, (state, action) => {
      let { payload, message } = action.payload
      state.validateVendorBankAccountResponse.isLoading = false;
      state.validateVendorBankAccountResponse.payload =  payload
      state.validateVendorBankAccountResponse.success = true
      state.validateVendorBankAccountResponse.message = message || ''

      state.updateVendorProfile.isLoading = false;
      state.updateVendorProfile.payload = payload;
      state.vendorProfile.payload = payload
      state.addressDetails = payload?.address;
      state.bankDetails = payload?.bankDetails;
      state.isAddressCompleted = payload?.isAddressCompleted;
      state.isBankDetailsCompleted = payload?.isBankDetailsCompleted;
      state.basicDetails = {
        email: payload?.email,
        firstName: payload?.firstName || '',
        lastName: payload?.lastName || '',
        phone: payload?.phone || '',
        profileVerified: payload?.vendorProfileCompleted

      }
      state.updateVendorProfile.success = true;
      state.updateVendorProfile.message = message || payload?.message || '';


    })
    .addCase(validateVendorBankAccount.rejected, (state, action) => {
      state.updateVendorProfile.isLoading = false;
      // state.error = action?.error as string;
      state.updateVendorProfile.success = false


      state.validateVendorBankAccountResponse.isLoading =  false
      state.validateVendorBankAccountResponse.error =   action?.error ||action?.payload || "Something went wrong"
      state.validateVendorBankAccountResponse.success = false   
     });

    // --------------------------------------------------------------------------------

    builder
    .addCase(vendorDashboardDetails.pending, (state) => {
      state.vendorDashboardDetailsResponse.isLoading = true;
      state.vendorDashboardDetailsResponse.error = null;
      state.vendorDashboardDetailsResponse.success = false
    })
    .addCase(vendorDashboardDetails.fulfilled, (state, action) => {
      let { payload, message ,success} = action.payload
      state.vendorDashboardDetailsResponse.isLoading = false;
      state.vendorDashboardDetailsResponse.payload = payload;
      state.vendorDashboardDetailsResponse.message = message
      state.vendorDashboardDetailsResponse.success = success


    })
    .addCase(vendorDashboardDetails.rejected, (state, action) => {
      state.vendorDashboardDetailsResponse.isLoading = false;
      // state.error = action?.error as string;
      state.vendorDashboardDetailsResponse.success = false
    });


     // --------------------------------------------------------------------------------

     builder
     .addCase(getCustomerByPhone.pending, (state) => {
       state.getCustomerByPhoneResponse.isLoading = true;
       state.getCustomerByPhoneResponse.error = null;
       state.getCustomerByPhoneResponse.success = false
     })
     .addCase(getCustomerByPhone.fulfilled, (state, action) => {
       let { payload, message ,success} = action.payload
       state.getCustomerByPhoneResponse.isLoading = false;
       state.getCustomerByPhoneResponse.payload = payload;
       state.getCustomerByPhoneResponse.message = message
       state.getCustomerByPhoneResponse.success = success
 
 
     })
     .addCase(getCustomerByPhone.rejected, (state, action) => {
       state.getCustomerByPhoneResponse.isLoading = false;
       // state.error = action?.error as string;
       state.getCustomerByPhoneResponse.success = false
     });

  
  },
});

export const {
  updateAddressDetails,
  updateBankDetails,
  setAddressCompleted,
  setBankDetailsCompleted,
  setLoading,
  setError,
  setBasicDetailsCompleted,
  updateBasicDetails
} = profileSlice.actions;
export default profileSlice.reducer;
